import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconPayment.tsx
const IconPayment = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M10.782 11.805q.732 0 1.206.263.48.258.715.71.24.445.235 1.008a1.97 1.97 0 0 1-.235 1 1.6 1.6 0 0 1-.726.668q-.488.24-1.242.241h-2.31v-3.89z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M10.782 11.805q.732 0 1.206.263.48.258.715.71.24.445.235 1.008a1.97 1.97 0 0 1-.235 1 1.6 1.6 0 0 1-.726.668q-.488.24-1.242.241h-2.31v-3.89z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "m28.624 6.667-25.25.01c-.868 0-1.573.7-1.573 1.564l.01 15.518c0 .869.7 1.574 1.563 1.574l25.25-.002c.806 0 1.483-.786 1.574-1.564l-.01-15.526c0-.869-.7-1.574-1.564-1.574M6.257 15.695V10h4.525q1.394 0 2.36.504.968.498 1.466 1.354.503.849.504 1.91 0 1.1-.51 1.938-.51.833-1.477 1.308-.966.468-2.343.468H8.426v.891h2.63v1.787h-2.63V22H6.257v-1.84H4.494v-1.787h1.763v-.89H4.494v-1.788zm4.525-3.89q.732 0 1.206.263.48.258.715.71.24.445.235 1.008a1.97 1.97 0 0 1-.235 1 1.6 1.6 0 0 1-.726.668q-.488.24-1.242.241h-2.31v-3.89z",
			clipRule: "evenodd"
		})
	]
});
var IconPayment_default = forwardRef(IconPayment);
//#endregion
export { IconPayment_default as default };
